import React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import Toasts from "../../components/subcomponents/Toasts";
import Snackbars from "../../components/subcomponents/SnackBar/Snackbars";
import Login_Account from "../../components/Auth/Login_Account";
//import {redirectToCiamLogin} from "../../components/Auth/Login_Account";
import * as Constants from "../../../constants/Constants";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "../../../../authConfig";

@connect(store => {
  return {
    isAuthenticated: store.auth.isAuthenticated,
    forgotPassFlg: store.auth.forgotPassFlg,
    passResetLogin: store.auth.passResetLogin,
    loginFailed: store.auth.loginFailed,
    loginFetching: store.auth.fetching,
    loginMes: store.auth.loginMes,
    loginSuccess: store.auth.loginSuccess,
    userProfile: store.userProfile.userProfile,
    loginDetails:store.auth.loginDetails
  };
})
export default class Login extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    component: "loading_userManagement"
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.props.isAuthenticated != nextProps.isAuthenticated &&
      nextProps.isAuthenticated
    ) {
      this.setState({ component: "loading" });
    }
  }
  componentDidMount() {
    if (this.props.isAuthenticated == false) {
      this.setState({ component: "login" });
    }
  }
 /* getRedirectURL(usertype,packingType){
    
    if( usertype ==="PSBU" && packingType==="Packaging Apps"){
      return "/packageinfo";
    }
    if( usertype ==="BOSCH" && packingType==="Packaging Bosch"){
      return "/packageinfo";
    }
    if( usertype ==="EDGE" && packingType==="Packaging Apps"){
      return "/packageinfo";
    }
    if( usertype ==="BOSCH" && packingType==="Packaging Kubota"){
      return "/packageinfo";
    }
    if( usertype ==="BOSCH" && packingType==="User Admin"){
      return "/userManagement";
    }
    if( usertype ==="BOSCH" && packingType==="System Admin"){
      return "/packageTypeManagement";
    }
  }*/
  getRedirectPath() {
    if(this.props.loginDetails.user_roles.length>0){
      const usertype = this.props.loginDetails.user_type.user_type;
      for (var i = 0; i < this.props.loginDetails.user_roles.length; i++) {
        const packingType = this.props.loginDetails.user_roles[i].role_name;
        if(this.props.loginDetails.user_roles[i].role_access=="Packaging"){
          return "/packageinfo";
        }else if(this.props.loginDetails.user_roles[i].role_access=="User Admin"){
          return "/userManagement";
        }else if(this.props.loginDetails.user_roles[i].role_access=="System Admin"){
          return "/packageTypeManagement";
        }
        //return this.getRedirectURL(usertype,packingType);
      }
    }

}
redirectToCiamLogin = (event) => {
//  event.preventDefault();
  let ctx = this;
  this.sendGetRequest(Constants.CONFIG.discovery_endpoint, function (request, body) {
      // Save the endpoints for later use
      localStorage.setItem("authorization_endpoint", body.authorization_endpoint);
      localStorage.setItem("token_endpoint", body.token_endpoint);
      localStorage.setItem("end_session_endpoint", body.end_session_endpoint);
      localStorage.setItem("userinfo_endpoint", body.userinfo_endpoint);
      localStorage.setItem("jwks_uri", body.jwks_uri);
      sessionStorage.setItem("platform", Constants.SKID);

      // save the state
      localStorage.setItem("ciam_state", Constants.CONFIG.state);

      var params = {
          response_type: "code",
          client_id: encodeURIComponent(Constants.CONFIG.client_id),
          state: encodeURIComponent(Constants.CONFIG.state),
          scope: encodeURIComponent(Constants.CONFIG.requested_scopes),
          redirect_uri: encodeURIComponent(Constants.CONFIG.redirect_uri),
          style_id: encodeURIComponent(Constants.CONFIG.styleId)
      }

      var finalParams = Object.keys(params).map(key => key + '=' + params[key]).join('&');
      // Build the authorization URL
      var url = localStorage.getItem("authorization_endpoint") + "?" + finalParams;

      ctx.sendGetRequest(body.jwks_uri, function (request, res) {
        for (let i = 0; i < res.keys.length; i++) {
          if (res.keys[i].x5c !== undefined) {
              localStorage.setItem("public_key_id", res.keys[1].kid);
              localStorage.setItem("certificate", res.keys[1].x5c[0]);
              break;
          }
      }
        // Redirect to the authorization server
        window.location = url;
      });
  }, function (request, error) {
      // This could be an error response from the OAuth server, or an error because the 
      // request failed such as if the OAuth server doesn't allow CORS requests
      showToastError(error.error_description);
  });
}

redirectToAzureLogin() {
  let ctx = this;
  msalConfig.auth.redirectUri = process.env.AZURE_REDIRECT_URL;
  const msalInstance = new PublicClientApplication(msalConfig);
  msalInstance.loginPopup(loginRequest)
  .then(body => {
      console.log(body);
      sessionStorage.setItem("platform", Constants.AZURE);
      sessionStorage.setItem("email", body.account.idTokenClaims.email);
      sessionStorage.setItem("access_token", body.accessToken);
      sessionStorage.setItem("id_token", body.idToken);
      sessionStorage.setItem("isAuthenticated", true);
      sessionStorage.setItem("ciam_email_id", body.account.idTokenClaims.email);
      sessionStorage.setItem("jwks_uri", msalConfig.auth.authority + "/discovery/v2.0/keys");

      ctx.sendGetRequest(sessionStorage.getItem("jwks_uri"), function (request, res) {
        for (let i = 0; i < res.keys.length; i++) {
          if (res.keys[i].kid !== null) {
              localStorage.setItem("public_key_id", res.keys[i].kid);
              localStorage.setItem("certificate", res.keys[i].x5c[0]);
              break;
          }
        }
      window.location.href = "/packageinfo";
      });

  });
}

// Make a GET request and parse the response as JSON
sendGetRequest(url, success, error) {
  var request = new XMLHttpRequest();
  request.open('GET', url, true);
  request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
  request.onload = function () {
      var body = {};
      try {
          body = JSON.parse(request.response);
      } catch (e) { }
      if (request.status == 200) {
          success(request, body);
      } else {
          error(request, body);
      }
  }
  request.onerror = function () {
      error(request, {});
  }
  request.send();
}

  /*  const locationState = this.props.location.state;
    if (locationState && locationState.from.pathname) {
      return locationState.from.pathname; // redirects to referring url
    } else {
      return this.props.userProfile.roleType == Constants.FOTAADMIN
        ? "/admin/"
        : "/packageinfo";
    }
  }*/

  render() {
    let loc = this.props.location.pathname;
    let hrefSSO = this.props.location.search.toString();
    console.log("this.props.location.pathname"+this.props.location.pathname);
    if(loc.indexOf("ssologin")!=-1){
      if (hrefSSO.includes(Constants.AZURE)) {
        this.redirectToAzureLogin();
      } else this.redirectToCiamLogin();
      return (
        <div >
         <span>Please wait!!!</span>
        </div>      
    );
    }else{
    if (this.props.isAuthenticated) {
      return (
        <Redirect
          to={{
            pathname: this.getRedirectPath(),
            state: {
              from: this.props.location
            }
          }}
        />
      );
    }
    return (
      <div id = "mainLoginDiv">
        <Login_Account/>  
      </div>      
  );
  }
    
  }
}
